import React from 'react';
import { useActivation } from '@context/MobileOne';

// Import each ActivationStep component separately
import { ActivationStep0 } from './Step0';
import { ActivationStep1 } from './Step1';
import { ActivationStep2 } from './Step2';
import { ActivationStep3 } from './Step3';
import { ActivationStep4 } from './Step4';
import { ActivationStep5 } from './Step5';
import { ActivationStep6 } from './Step6';
import { ActivationStep7 } from './Step7';
import { ActivationStep8 } from './Step8';
import { ActivationStep9 } from './Step9';
import { ActivationStep10 } from './Step10';

export function Activation() {
  const { currentStep } = useActivation();

  const getCurrentStep = () => {
    switch (currentStep) {
      case 0:
        return <ActivationStep0 />;
      case 1:
        return <ActivationStep1 />;
      case 2:
        return <ActivationStep2 />;
      case 3:
        return <ActivationStep3 />;
      case 4:
        return <ActivationStep4 />;
      case 5:
        return <ActivationStep5 />;
      case 6:
        return <ActivationStep6 />;
      case 7:
        return <ActivationStep7 />;
      case 8:
        return <ActivationStep8 />;
      case 9:
        return <ActivationStep9 />;
      case 10:
        return <ActivationStep10 />;
      default:
        return <ActivationStep0 />;
    }
  };

  return <>{getCurrentStep()}</>;
}

export default Activation;
